'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.a = exports.AtpArray = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _object = require('./object');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Array convenience functions
 */
var AtpArray = exports.AtpArray = function (_AtpObject) {
    _inherits(AtpArray, _AtpObject);

    function AtpArray() {
        _classCallCheck(this, AtpArray);

        return _possibleConstructorReturn(this, (AtpArray.__proto__ || Object.getPrototypeOf(AtpArray)).apply(this, arguments));
    }

    _createClass(AtpArray, [{
        key: 'difference',

        /**
         * Returns a new array with all elements of 'other' removed from the original array
         * @param {Array} other - An array holding the elements to remove from the original array
         * @returns {Array}
         * @example a([1, 2, 3, 4, 5, 6, 7, 8, 9, 10])
         *  .difference([1, 2, 3]) ==
         *  [4, 5, 6, 7, 8, 9, 10]
         */
        value: function difference(other) {
            return other ? this.raw.filter(function (item) {
                return !other.includes(item);
            }) : [];
        }

        /**
         * Returns a new array that contains only the elements that are in both the original array and the 'other' array
         * @param {Array} other
         * @returns {Array}
         * @example a([1, 2, 3, 4, 5, 6, 7, 8, 9, 10])
         *  .intersect([1, 2, 3]) ==
         *  [1, 2, 3]
         */

    }, {
        key: 'intersect',
        value: function intersect(other) {
            return other ? this.raw.filter(function (item) {
                return other.includes(item);
            }) : [];
        }

        /**
         * Sorts an array of objects by a given field.  The sort is done lexographically
         * @param {String} fieldName - the field to sort by
         * @returns {Array}
         * @example a([{name: "Joe"}, {name: "Bob"}, {name: "Ann"}])
         *  .sortBy("name") ==
         *  [{name: "Ann"}, {name: "Bob"}, {name: "Joe"}]
         */

    }, {
        key: 'sortBy',
        value: function sortBy(fieldName) {
            return this.raw.sort(function (a, b) {
                return a[fieldName].localeCompare(b[fieldName]);
            });
        }

        /**
         * Partitions the elements of an array into separate arrays based on a partition function.
         * @param {Function} partitionFunc - A function that will be applied to each element in the array.
         * @returns {Object}
         * @example a([1, 2, 3, 4, 5, 6, 7, 8, 9, 10])
         *  .partition(n => n % 3) ==
         *  {
         *      0: [3, 6, 9],
         *      1: [1, 4, 7, 10],
         *      2: [2, 5, 8]
         *  }
         */

    }, {
        key: 'partition',
        value: function partition(partitionFunc) {
            return (0, _object.o)(this.reduce(function (partitioned, cur) {
                return (0, _object.o)(partitionFunc(cur)).as(function (key) {
                    return Object.assign({}, partitioned, _defineProperty({}, key, partitioned[key] ? partitioned[key].concat(cur) : [cur]));
                });
            }, {}));
        }

        /**
         * Returns the maximum element in the array
         * @returns {Number}
         */

    }, {
        key: 'max',
        value: function max() {
            return Math.max.apply(Math, _toConsumableArray(this.raw));
        }
    }]);

    return AtpArray;
}(_object.AtpObject);

/**
 * Wraps an array in an ATPArray
 * @param {Array} obj
 */


var a = exports.a = function a(obj) {
    return obj instanceof AtpArray ? obj : new AtpArray(obj);
};